/*****************************************************************************
 @author: Sandeep Sirohi
 @date: 28/08/2024
 @description: Kendo editor custom fonts.
 ***************************************************************************/
import * as React from "react";
import { EditorTools, EditorToolsSettings } from "@progress/kendo-react-editor";

const fontNameToolSettings = {
    ...EditorToolsSettings.fontName,
    items: [
        { text: "Rajdhani", value: "Rajdhani" },
        { text: "Arial", value: "Arial" },
        { text: "Arial Black", value: "Arial Black" },
        { text: "Comic Sans MS", value: "Comic Sans MS" },
        { text: "Impact", value: "Impact" },
        { text: "Tahoma", value: "Tahoma" },
        { text: "Times New Roman", value: "Times New Roman" },
        { text: "Verdana", value: "Verdana" },
        { text: "Calibri", value: "Calibri" },
    ],
};

// Creates custom fontName tool.
const CustomFontName =
    EditorTools.createStyleDropDownList(fontNameToolSettings);

// Styles the fontName tool (DropDownList).
const EditorFont = (props) => (
    <CustomFontName
        {...props}
        style={{
            width: "150px",
            ...props.style,
        }}
    />
);

export default EditorFont;